export const commonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => {
    const parentContainerHeight = FOUNDATIONS.size_1089;
    return {
        parentContainer: {
            display: 'flex',
            width: `calc(${parentContainerHeight} * 3 / 2)`, // 3:2 aspect ratio
            height: parentContainerHeight,
            max_height: parentContainerHeight,
            padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_300}`,
            flex_direction: 'column',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_150,
            flex_shrink: '0',
            border_radius: FOUNDATIONS.radius_00,
            background: FOUNDATIONS.color_neutral_bg_onsurface_100,
            cursor: 'pointer',
            ...STATE_TOKENS.parentContainer,
        },
        logosContainer: {
            display: 'flex',
            justify_content: 'space-between',
            align_items: 'center',
            align_self: 'stretch',
            ...STATE_TOKENS.logosContainer,
        },
        brandIcon: {
            height: FOUNDATIONS.size_150,
            ...STATE_TOKENS.brandIcon,
        },
        brandIllustration: {
            height: FOUNDATIONS.size_150,
            ...STATE_TOKENS.brandIllustration,
        },
        statusIcon: {
            width: FOUNDATIONS.size_200,
            height: FOUNDATIONS.size_200,
            ...STATE_TOKENS.statusIcon,
        },
        previewPDFImageContainer: {
            width: '100%',
            height: '100%',
            background_size: 'contain',
            background_position: 'center',
            background_repeat: 'no-repeat',
            ...STATE_TOKENS.previewPDFImageContainer,
        },
    };
};
//# sourceMappingURL=commonStyles.js.map